<template>
  <div>
    <div style="margin-bottom: 10px;font-size: 18px">
      成本明细配置-{{costCategory.name || ''}}
    </div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQueryMy">
        <a-row :gutter="24">

          <a-col :xl="12">
            <a-form-item label="表单CODE">
              <a-input placeholder="请输入表单CODE" v-model="queryParam.formCode"></a-input>
            </a-form-item>
          </a-col>

<!--          <a-col :xl="12" >-->
<!--            <a-form-item label="耗材CODE">-->
<!--              <a-input placeholder="请输入耗材CODE" v-model="queryParam.materialCode"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->

            <a-col :xl="12" >
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQueryMy" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAddMy" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEditMy(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <tempConfigCostItem-modal :category-code="this.costCategory.code" ref="modalForm" @ok="modalFormOk"></tempConfigCostItem-modal>
  </div>
</template>

<script>
  import '@assets/less/TableExpand.less'
  import TempConfigCostItemModal from './TempConfigCostItemModal.vue'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "TempConfigCostItemList",
    mixins:[JeecgListMixin],
    components: {
      TempConfigCostItemModal
    },
    props:{
      costCategory:{
        type:Object,
        default:()=>{
          return {}
        }
      },
    },
    data () {
      return {
        description: '成本明细管理页面',
        // 表头
        columns: [
		   {
            title: '表单CODE',
            align:"center",
            dataIndex: 'formCode'
           },
		   // {
       //      title: '耗材CODE',
       //      align:"center",
       //      dataIndex: 'materialCode'
       //     },
		   // {
       //      title: '表单数量',
       //      align:"center",
       //      dataIndex: 'formNum'
       //     },
		   // {
       //      title: '耗材数量',
       //      align:"center",
       //      dataIndex: 'materialNum'
       //     },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/tempconfig/tempConfigCostItem/list",
          delete: "/tempconfig/tempConfigCostItem/delete",
       },
        disableMixinCreated:true,
    }
  },
  computed: {
  },
    watch:{
      costCategory(){
        this.searchQueryMy()
      }
    },
    methods: {
      handleAddMy(){
        if(!this.costCategory.code){
          return this.$message.warning('请选择成本分类进行添加')
        }
        this.handleAdd()
      },
      handleEditMy(){
        if(!this.costCategory.code){
          return this.$message.warning('请选择成本分类进行添加')
        }
        this.handleEdit()
      },
      searchQueryMy(){
        this.baseQueryParam = {categoryCode:this.costCategory.code}
        this.loadData()
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>